import React from 'react';
import { connect } from 'react-redux';
import {
  apiGetCGRMAttenteDocumentByNumFic,
  apiGetCgrmDocuments,
  apiGetCGRMIndexedDocumentByNumFic,
  apiGetSpvieDocument
} from '../../Api/Documents/Documents';
import { TemplateDocumentSended } from '../../Templates'

class DocumentSended extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      datePending: [],
      dateResolved: [],
      documentSelected: null,
      file: {
        attachement: '',
        blob: '',
        url: ``
      }
    };
  }

  onReturn = () => {
    if (this.state.step === 1) {
      this.props.history.push('/documents');
    } else {
      this.setState({
        step: 1
      });
    }
  };

  componentDidMount() {
    this.getSendedDocuments();
  }

  getSendedDocuments = async () => {
    const res = await apiGetCgrmDocuments();
    console.log('RES SENDED', res);
    if (res.status === 200) {
      const auxTraiter = [];
      const auxNonTraiter = [];
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].status == 'Treated') {
          auxTraiter.push(res.data[i]);
        } else {
          auxNonTraiter.push(res.data[i]);
        }
      }
      this.setState({
        dateResolved: auxTraiter,
        datePending: auxNonTraiter
      });
    }
  };

  onDowLoad = async (el) => {
    let res = null;
    if (el.numFic !== 0) {
      res = await apiGetCGRMAttenteDocumentByNumFic(el.numFic);
    } else {
      res = await apiGetSpvieDocument(el.attachmentInfoId);
    }
    console.log('RES ON DOWNLOAD', res);
    if (res.status === 200) {
      const { blob, url } = await this.createBlob(
        res.fichiertrt || res.base64pdf,
        res.mimeType
      );
      this.setState({
        file: {
          attachement: res,
          blob: blob,
          url: `${url}`,
          mimeType: res.mimeType
        }
      });
      if (url) {
        const download = document.createElement('a');
        download.setAttribute('href', url);
        // this.state.file.attachement.type == 'application/pdf' &&
        download.setAttribute('target', '_blank');
        download.click();
      }
    }
  };

  onOpen = async (el) => {
    let res = null;
    if (el.numFic !== 0) {
      res = await apiGetCGRMAttenteDocumentByNumFic(el.numFic);
    } else {
      res = await apiGetSpvieDocument(el.attachmentInfoId);
    }

    console.log('RES ON OPEN', res);
    if (res.status === 200) {
      const { blob, url } = await this.createBlob(
        res.fichiertrt || res.base64pdf,
        res.mimeType
      );
      this.setState({
        documentSelected: el,
        step: 2,
        file: {
          attachement: res,
          blob: blob,
          url: `${url}`,
          mimeType: res.mimeType || res.extension
        }
      });
    }
  };

  createBlob = async (data, mimeType = 'application/pdf') => {
    try {
      console.log('MIMETYPE', mimeType);
      const blob = await (
        await fetch(`data:${mimeType};base64,${data}`)
      ).blob();
      const url = URL.createObjectURL(blob);
      return { blob, url };
    } catch (err) {}
  };

  render() {
    return (
      <TemplateDocumentSended
        state={this.state}
        onReturn={this.onReturn}
        onDowLoad={this.onDowLoad}
        onOpen={this.onOpen}
        user={this.props.user}
        file={this.state.file}
      />
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: (action) => {
      dispatch(action);
    }
  };
};
const mapStateToProps = (state) => ({
  user: state.auth.user
});
export default connect(mapStateToProps, mapDispatchToProps)(DocumentSended);
